import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { Theme } from '../../../../config/theme';

import Warning from '-!svg-react-loader!./warning.svg'; // eslint-disable-line
import UserImage from '../../../UserImage';

export default class Profile extends Component {
  render() {
    return (
      <li className={css(styles.profile)}>
        <Link to={`/${this.props.dog ? 'pooch' : 'profile'}/${this.props.id}`}>
          <UserImage styles={styles.profile_image} image={this.props.image} />
        </Link>
        <div className={css(styles.profile_details)}>
          <div className={css(styles.profile_name)}>{this.props.name}</div>
          <div className={css(styles.profile_status)}>
            {!this.props.published ? <Warning className={css(styles.profile_status_icon)} /> : null}
            {this.props.published ? 'Published' : 'Incomplete'}
          </div>
        </div>
        <Link
          to={`/${this.props.dog ? 'pooch' : 'profile'}/${this.props.id}/edit`}
          onClick={this.props.callback}
          className={css(styles.profile_edit)}>
          Edit
        </Link>
      </li>
    );
  }
}

Profile.defaultProps = {
  dog: true,
  published: false,
  callback: () => {},
};

Profile.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  dog: PropTypes.bool,
  published: PropTypes.bool,
  callback: PropTypes.func,
};

const styles = StyleSheet.create({
  profile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px 12px 12px',
    borderBottom: '1px solid #16345a',
  },

  profile_image: {
    height: 55,
    width: 55,
    marginLeft: 0,
    marginRight: 15,
  },

  profile_details: {
    flexGrow: 1,
  },

  profile_name: {
    marginBottom: 8,
    fontSize: 17,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
  },

  profile_status: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: Theme.font_family_secondary,
    fontSize: 11,
    fontWeight: Theme.font_weight_secondary,
    lineHeight: 1,
    letterSpacing: 1.5,
    color: Theme.white,
    textTransform: 'uppercase',
  },

  profile_status_icon: {
    position: 'relative',
    top: -1,
    marginRight: 12,
  },

  profile_edit: {
    fontFamily: Theme.font_family_secondary,
    fontSize: 15,
    fontWeight: Theme.font_weight_secondary,
    lineHeight: 1.73,
    letterSpacing: 2,
    color: '#39b4d6',
    textTransform: 'uppercase',
  },
});



// WEBPACK FOOTER //
// ./src/components/UserMenu/components/Profile/index.js